import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button, Paper, Typography, CircularProgress
} from '@mui/material';
import { Box } from '@mui/system';
import { Add } from '@mui/icons-material';
import DataGridDbUsers from './DataGridDbUsers';
import { ROUTE_DB_USERS } from '../routes/Routes';
import { useAuth } from '../hooks/useAuth';
import { sortRegions } from "../util/_helpers";
import GetFetch from '../hooks/GetFetch';
import ClosingAlert from '../components/ClosingAlert';


const DbUsers = () => {
    const title = ROUTE_DB_USERS.title;
    const navigate = useNavigate();
    const { user } = useAuth();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    useEffect(() => {
        document.title = title;
        const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page == "ROUTE_DB_USERS") })
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const { Errors, Message, Success } = await GetFetch(
            '/v1/PgRoles/GetRoles'
        );
        if (Success === true) {
            setData(Message);
            setError(false);
            setErrorMessage(null);
        }
        else {
            setError(true);
            setErrorMessage(Errors[0].Message);
            handleSettingData(null);
            console.error("What went wrong:", Errors);
        }
        setLoading(false);
    };


    return (
        <div>
            <Typography
                className="title-database-users"
                component="div"
            >
                <h1 style={{ color: "#06152B" }}> {title} </h1>
            </Typography>
            {
                (data) &&

                <DataGridDbUsers
                    data={data}
                />
            }
            <ClosingAlert
                severity="error"
                message={errorMessage}
                visible={error && !loading}
                hideAlert={() => { setError(false) }}
            />
            {
                (loading) &&
                <CircularProgress color="secondary" />
            }
        </div>
    );
};

export default DbUsers;